import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.927 0C10.713 0 0 10.712 0 23.926c0 13.215 10.713 23.926 23.927 23.926s23.926-10.711 23.926-23.926C47.853 10.713 37.142.001 23.926.001zm10.972 34.509a1.49 1.49 0 0 1-2.051.494c-5.618-3.432-12.69-4.209-21.019-2.306a1.492 1.492 0 0 1-.663-2.908c9.114-2.084 16.932-1.186 23.239 2.668.703.432.926 1.349.494 2.052m2.929-6.516a1.865 1.865 0 0 1-2.566.616c-6.431-3.954-16.235-5.1-23.842-2.79a1.87 1.87 0 0 1-2.328-1.243 1.87 1.87 0 0 1 1.244-2.327c8.69-2.636 19.492-1.359 26.877 3.18a1.864 1.864 0 0 1 .615 2.564m.251-6.784c-7.711-4.58-20.434-5.002-27.797-2.767a2.238 2.238 0 1 1-1.299-4.283c8.452-2.566 22.502-2.07 31.38 3.2a2.235 2.235 0 0 1 .783 3.067 2.236 2.236 0 0 1-3.066.783"
    }, null, -1)
  ]))]))
}
export default { render: render }